import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {UnsubscribeOnDestroyAdapter} from '@shared';
import {DefaultResponse} from "@core/models/Http/DefaultResponse";
import {environment} from "@enviroment/environment";
import {Diagnostic} from "@core/models/Diagnostic";
import {HttpMesageHandlerService} from "@core/service/http-mesage-handler";


@Injectable({
  providedIn: 'root',
})

export class DiagnosticService extends UnsubscribeOnDestroyAdapter {
  isTblLoading = true;
  dataChange: BehaviorSubject<Diagnostic[]> = new BehaviorSubject<Diagnostic[]>([]);

  constructor(
    private httpClient: HttpClient,
    private httpMsgHandler: HttpMesageHandlerService
  ) {
    super();
  }

  get data(): Diagnostic[] {
    return this.dataChange.value;
  }

  /** CRUD METHODS */
  getAllDiagnostics(name: string): void {
    // Puedes poner valores por defecto segun lo que la API acepte si solo quieres el catalogo general
    const body = {
      nombre: name
    };

    if (name) {
      this.subs.sink = this.httpClient.post<DefaultResponse<Diagnostic[]>>(
        `${environment.backend_url}VIDAL_CIM10/CIM10ByName`,
        body
      ).subscribe({
        next: (data) => {
          this.isTblLoading = false;
          this.dataChange.next(data.data);
        },
        error: (error: HttpErrorResponse) => {
          this.isTblLoading = false;
          this.httpMsgHandler.handleMsg(error);
        }
      });
    } else {
      this.isTblLoading = false;
      this.dataChange.next([]);
    }
  }

}
